<!-- Sidepanel Left -->
<app-left-side-bar></app-left-side-bar>

<!-- Sidepanel Right -->
<!-- <app-right-side-bar></app-right-side-bar> -->
